import React, { useEffect, useState } from "react";
import Axios from "../../../axios/axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import SupplierNavbar from "../Admin/SuppplierNavbar";
import SupplierSidebar from "../Admin/SupplierSidebar";

function BldEdit() {
  const [formData, setFormData] = useState({
    meterialName: "",
    partNo: "",
    meterialcode: "",
    modelId: { _id: "", name: "" },
    brandId: { _id: "", name: "" },
    categoryId: { _id: "", name: "" },
    regionId: { _id: "", name: "" },
    year: "",
    pricePerUnit: "",
    weightPerUnit: "",
    productType: "",
    photos: [],
    supplier: {
      supplierId: "",
      name: "",
      location: "",
      contactNumber: "",
      email: "",
      description: "",
    },
    selectedSupplier: null,
    features: [],
    manufacturer: "",
    application: [],
    handlingInstructions: "",
    newFeature: "",
    newApplication: "",
  });

  const [Materialbrands, setMaterialbrand] = useState([]);
  const [Materalcategories, setMaterialcategory] = useState([]);
  const [Materialmodels, setMaterialModels] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [regions, setRegions] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const productTypeOptions = ["Engineering", "Building", "Auto-Spare"];
  const { id } = useParams();
  const [errorFeature, setErrorFeature] = useState("");
  const [errorApplication, setErrorApplication] = useState("");
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [manufacturers, setManufacturers] = useState([]);

  useEffect(() => {
    const storedSupplier = sessionStorage.getItem("supplierInfo");
    if (storedSupplier) {
      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);
    }
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    fetchMaterialData();
    getCompleteData();
  }, [id]);

  useEffect(() => {
    const fetchLoggedInSupplier = async () => {
      try {
        const supplierInfo = JSON.parse(sessionStorage.getItem("supplierInfo"));
        console.log("Session supplierInfo:", supplierInfo);

        if (!supplierInfo?.supplierId) {
          console.error("No supplier ID found in session");
          toast.error("Supplier information not found");
          return;
        }

        const response = await Axios.get(
          `/supplier/get/${supplierInfo.supplierId}`
        );
        console.log("Supplier API response:", response);
        const apiData = response.data?.data;
        console.log("Supplier API data:", apiData);

        if (!apiData) {
          throw new Error("No supplier data returned from API");
        }

        setFormData((prev) => ({
          ...prev,
          supplier: {
            supplierId: apiData._id,
            name: apiData.supplierName || "",
            location: apiData.address || "",
            contactNumber: apiData.phoneNumber || "",
            email: apiData.emailAddress || "",
            description: apiData.description || "",
          },
          selectedSupplier: apiData,
        }));
      } catch (error) {
        console.error("Error fetching supplier:", error);
        toast.error("Failed to load supplier information");
      }
    };

    fetchLoggedInSupplier();
  }, []);

  //   const fetchMaterialData = async () => {
  //     try {
  //       const response = await Axios.get(`/meterials/get/${id}`);
  //       const materialData = response.data;

  //       setFormData({
  //         ...materialData,
  //         partNo: materialData.partNo || "",

  //         brandId: materialData.brandId || { _id: "", name: "" },
  //         categoryId: materialData.categoryId || { _id: "", name: "" },
  //         modelId: materialData.modelId || { _id: "", name: "" },
  //         regionId: materialData.regionId || { _id: "", name: "" },
  //         productType: materialData.productType || "",
  //         photos: materialData.photos || [],
  //         supplier: materialData.supplier || {
  //           supplierId: "",
  //           name: "",
  //           location: "",
  //           contactNumber: "",
  //           email: "",
  //         },
  //         features: materialData.features || [],
  //         application: materialData.application || [],
  //       });
  //     } catch (error) {
  //       console.error("Error fetching material data:", error);
  //       toast.error("Failed to load material data");
  //     }
  //   };

  const fetchMaterialData = async () => {
    try {
      const response = await Axios.get(`/meterials/get/${id}`);
      const materialData = response.data;

      setFormData((prev) => ({
        ...prev, // Keep any existing state (like selectedSupplier)
        ...materialData,
        partNo: materialData.partNo || "",
        brandId: materialData.brandId || { _id: "", name: "" },
        categoryId: materialData.categoryId || { _id: "", name: "" },
        modelId: materialData.modelId || { _id: "", name: "" },
        regionId: materialData.regionId || { _id: "", name: "" },
        productType: materialData.productType || "",
        photos: materialData.photos || [],
        manufacturer: materialData.manufacturer || "",
        features: materialData.features || [],
        application: materialData.application || [],
        // Don't overwrite supplier if it's already set from session
        supplier: prev.supplier.supplierId
          ? prev.supplier
          : materialData.supplier || {
              supplierId: "",
              name: "",
              location: "",
              contactNumber: "",
              email: "",
            },
      }));
    } catch (error) {
      console.error("Error fetching material data:", error);
      toast.error("Failed to load material data");
    }
  };
  const getCompleteData = async () => {
    try {
      const [detailsRes, suppliersRes, regionsRes, manufacturersRes] = await Promise.all([
        Axios.get("/type-based-details"),
        Axios.get("/supplier"),
        Axios.get("/regions"),
        Axios.get("/manufacturer"),
      ]);

      setMaterialModels(detailsRes.data.building?.models || []);
      setMaterialbrand(detailsRes.data.building?.brands || []);
      setMaterialcategory(detailsRes.data.building?.categories || []);
      setSuppliers(suppliersRes.data?.data || []);
      setRegions(regionsRes.data || []);
      setManufacturers(manufacturersRes.data || []);
    } catch (error) {
      console.error("Error fetching details:", error);
      toast.error("Failed to load supporting data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    setUploading(true);

    try {
      const uploadedPhotos = await Promise.all(
        Array.from(files).map(async (file) => {
          const formData = new FormData();
          formData.append("images", file);

          const config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };

          const { data } = await Axios.post(
            "/upload-multiple",
            formData,
            config
          );
          return {
            title: file.name,
            url: data.fileUrls[0],
            public_id: data.public_id,
          };
        })
      );

      setFormData((prev) => ({
        ...prev,
        photos: [...prev.photos, ...uploadedPhotos],
      }));
      toast.success("Images uploaded successfully");
    } catch (error) {
      console.error("Error uploading images:", error);
      toast.error("Failed to upload images");
    } finally {
      setUploading(false);
    }
  };

  const removePhoto = async (index, public_id) => {
    try {
      if (public_id) {
        await Axios.delete(`/meterial/delete-image/${id}`, {
          data: { public_id },
        });
      }

      setFormData((prev) => {
        const updatedPhotos = [...prev.photos];
        updatedPhotos.splice(index, 1);
        return { ...prev, photos: updatedPhotos };
      });

      toast.success("Image removed successfully");
    } catch (error) {
      console.error("Error removing image:", error);
      toast.error("Failed to remove image");
    }
  };

  const handleAddFeature = () => {
    if (!formData.newFeature || formData.newFeature.trim() === "") {
      setErrorFeature("Write Something");
      return;
    }
    setFormData((prev) => ({
      ...prev,
      features: [...prev.features, formData.newFeature.trim()],
      newFeature: "",
    }));
    setErrorFeature("");
  };

  const handleRemoveFeature = (index) => {
    setFormData((prev) => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index),
    }));
  };

  const handleAddApplication = () => {
    if (!formData.newApplication || formData.newApplication.trim() === "") {
      setErrorApplication("Write Something");
      return;
    }
    setFormData((prev) => ({
      ...prev,
      application: [...prev.application, formData.newApplication.trim()],
      newApplication: "",
    }));
    setErrorApplication("");
  };

  const handleRemoveApplication = (index) => {
    setFormData((prev) => ({
      ...prev,
      application: prev.application.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submissionData = {
        ...formData,
        supplier: {
          supplierId:
            formData.selectedSupplier?._id || formData.supplier?.supplierId,
          name:
            formData.selectedSupplier?.supplierName || formData.supplier?.name,
          location:
            formData.selectedSupplier?.address || formData.supplier?.location,
          contactNumber:
            formData.selectedSupplier?.phoneNumber ||
            formData.supplier?.contactNumber,
          email:
            formData.selectedSupplier?.emailAddress || formData.supplier?.email,
        },
      };

      const response = await Axios.put(
        `/meterials/update/${id}`,
        submissionData
      );
      toast.success("Material updated successfully");
      setTimeout(() => {
        navigate("/SupplierProducts");
      }, 1000);
    } catch (error) {
      console.error("Error updating material:", error);
      toast.error(error.response?.data?.message || "Failed to update material");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar />
            </div>
          )}

          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="row">
              <div className="col-12 grid-margin stretch-card">
                <div
                  className="card"
                  style={{
                    maxHeight: "95vh",
                    overflowY: "auto",
                    minHeight: "90vh",
                  }}
                >
                  <div className="card-body">
                    <h4 className="card-title">Edit Material</h4>
                    <form className="forms-sample" onSubmit={handleSubmit}>
                      {/* Basic Information */}
                      <div className="form-group">
                        <label>Material Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="meterialName"
                          value={formData.meterialName}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Part No</label>
                        <input
                          type="text"
                          className="form-control"
                          name="partNo"
                          value={formData.partNo}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="form-group">
                        <label>Description</label>
                        <textarea
                          className="form-control"
                          name="description"
                          value={formData.description}
                          onChange={handleInputChange}
                          rows="4"
                        />
                      </div>

                      <div className="form-group">
                        <label>Material Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="meterialcode"
                          value={formData.meterialcode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      {/* Dropdown Selections */}
                      <div className="form-group">
                        <label>Brand</label>
                        <select
                          name="brandId"
                          className="form-control"
                          value={formData.brandId._id}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              brandId: {
                                _id: e.target.value,
                                name:
                                  Materialbrands.find(
                                    (b) => b._id === e.target.value
                                  )?.name || "",
                              },
                            }))
                          }
                          required
                        >
                          <option value="">Select Brand</option>
                          {Materialbrands.map((brand) => (
                            <option key={brand._id} value={brand._id}>
                              {brand.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Model</label>
                        <select
                          name="modelId"
                          className="form-control"
                          value={formData.modelId._id}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              modelId: {
                                _id: e.target.value,
                                name:
                                  Materialmodels.find(
                                    (m) => m._id === e.target.value
                                  )?.name || "",
                              },
                            }))
                          }
                          required
                        >
                          <option value="">Select Model</option>
                          {Materialmodels.map((model) => (
                            <option key={model._id} value={model._id}>
                              {model.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Category</label>
                        <select
                          name="categoryId"
                          className="form-control"
                          value={formData.categoryId._id}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              categoryId: {
                                _id: e.target.value,
                                name:
                                  Materalcategories.find(
                                    (c) => c._id === e.target.value
                                  )?.name || "",
                              },
                            }))
                          }
                          required
                        >
                          <option value="">Select Category</option>
                          {Materalcategories.map((category) => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Region</label>
                        <select
                          name="regionId"
                          className="form-control"
                          value={formData.regionId._id}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              regionId: {
                                _id: e.target.value,
                                name:
                                  regions.find((r) => r._id === e.target.value)
                                    ?.name || "",
                              },
                            }))
                          }
                        >
                          <option value="">Select Region</option>
                          {regions.map((region) => (
                            <option key={region._id} value={region._id}>
                              {region.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Product Type</label>
                        <select
                          className="form-control"
                          name="productType"
                          value={formData.productType}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Product Type</option>
                          {productTypeOptions.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Specifications */}
                      <div className="form-group">
                        <label>Year</label>
                        <input
                          type="number"
                          className="form-control"
                          name="year"
                          value={formData.year}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Price Per Unit</label>
                        <input
                          type="number"
                          className="form-control"
                          name="pricePerUnit"
                          value={formData.pricePerUnit}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Weight Per Unit</label>
                        <input
                          type="number"
                          className="form-control"
                          name="weightPerUnit"
                          value={formData.weightPerUnit}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                     <div className="form-group">
  <label>Manufacturer</label>
  <select
    className="form-control"
    name="manufacturer"
    value={formData.manufacturer}
    onChange={handleInputChange}
    required
  >
    <option value="">Select Manufacturer</option>
    {manufacturers.map((man) => (
      <option key={man._id} value={man._id}>
        {man.manufacturerName}
      </option>
    ))}
  </select>
</div>


                      <div className="form-group">
                        <label>Handling Instructions</label>
                        <textarea
                          className="form-control"
                          name="handlingInstructions"
                          value={formData.handlingInstructions}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      {/* Features Section */}
                      <div className="form-group">
                        <label>Features</label>
                        <div className="d-flex mb-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Add feature"
                            value={formData.newFeature}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                newFeature: e.target.value,
                              }))
                            }
                          />
                          {errorFeature && (
                            <p className="text-danger mt-1">{errorFeature}</p>
                          )}
                          <button
                            type="button"
                            className="btn btn-primary ms-2"
                            onClick={handleAddFeature}
                          >
                            Add
                          </button>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {formData.features.map((feature, index) => (
                            <div key={index} className="d-flex mt-3">
                              <span>{feature}</span>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm ms-2"
                                onClick={() => handleRemoveFeature(index)}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Applications Section */}
                      <div className="form-group">
                        <label>Applications</label>
                        <div className="d-flex mb-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Add application"
                            value={formData.newApplication}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                newApplication: e.target.value,
                              }))
                            }
                          />
                          {errorApplication && (
                            <p className="text-danger mt-1">
                              {errorApplication}
                            </p>
                          )}
                          <button
                            type="button"
                            className="btn btn-primary ms-2"
                            onClick={handleAddApplication}
                          >
                            Add
                          </button>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {formData.application.map((application, index) => (
                            <div key={index} className="d-flex mt-3">
                              <span>{application}</span>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm ms-2"
                                onClick={() => handleRemoveApplication(index)}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Photos Upload */}
                      <div className="form-group">
                        <label>Photos</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleFileUpload}
                          multiple
                          accept="image/*"
                        />
                        {uploading && (
                          <div
                            className="spinner-border spinner-border-sm mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Uploading...
                            </span>
                          </div>
                        )}
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {formData.photos.map((photo, index) => (
                            <div key={index} className="position-relative">
                              <img
                                src={photo.url}
                                alt={photo.title}
                                className="img-thumbnail"
                                style={{ height: "100px", width: "auto" }}
                              />
                              <button
                                type="button"
                                className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                onClick={() =>
                                  removePhoto(index, photo.public_id)
                                }
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Supplier */}
                      <div className="form-group">
                        <label>Supplier</label>
                        <input
                          type="text"
                          className="form-control mt-2"
                          value={
                            formData.selectedSupplier?.supplierName ||
                            "Loading..."
                          }
                          placeholder="Supplier Name"
                          readOnly
                        />
                      </div>

                      {/* Submit Button */}
                      <button
                        type="submit"
                        className="btn btn-primary me-2"
                        disabled={loading || uploading}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Updating...
                          </>
                        ) : (
                          "Update Material"
                        )}
                      </button>
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => navigate("/SupplierProducts")}
                      >
                        Cancel
                      </button>
                      <div style={{ marginBottom: "60px" }}></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BldEdit;
